import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Generated class for the BaoxianProdunctInfoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'baoxian-produnct-info',
  templateUrl: 'baoxian-produnct-info.html'
})
export class BaoxianProdunctInfoComponent {

  text: SafeHtml;

  constructor( public params: NavParams,
    private sanitizer: DomSanitizer,
    public viewCtrl: ViewController) {
    var info = params.get("info");
    this.text = this.sanitizer.bypassSecurityTrustHtml(info);
    console.log(this.text);    
  }

  close(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/baoxian-produnct-info/baoxian-produnct-info.ts